import React, { useEffect } from 'react';
import { SVGBooking } from '../../../../assets/icons/SVGBooking';
import { SVGRestart } from '../../../../assets/icons/SVGRestart';
import { SelfTestResultProps } from '../../../../components/self-test/model/SelfTestResultProps';
import './self-test-result.scss';
import { UrlService } from '../../../../core/services/UrlService';
import { result } from '../data/result';
import { TrackingService } from '../../../../core/services/TrackingService';
// type Props = {
//     // title: string;
//     // content: string;
//     image?: string;
//     onReset: (answer?: string) => any;
// }

const HPyloriSelfTestResult: React.FC<SelfTestResultProps> = (props: SelfTestResultProps) => {
    const handleResetClick = (ev: any) => {
        props.onReset();
    }

    const [isHighRisk, setIsHighRisk] = React.useState<boolean>(false);

    React.useEffect(() => {
        const r = result(props.answers);
        setIsHighRisk(r.risk);
    }, [props.answers]);


    const track = () => {
        TrackingService.trackCustomEvent({
            category: 'patient-care',
            action: 'register_button_click',
            label: 'hpylori',
            params: {
                campaign_name: 'hpylori',
                step: 'link-click',
            }
        });
    };

    return (
        <div id='result' className="self-test__test-result">
            <div className="self-test__test-result-sizer">
                <div className="self-test__test-result-cover">
                    <img src={UrlService.getLocalImageUrl('patient-care/h-pylori/result_792x680.png')} alt="" />
                </div>
                <div className="self-test__test-result-content">
                    <div className="self-test__test-result-content-top">
                        <div className="self-test__test-result-content-container">
                            <div className="title">
                                評分機制及結果:
                                {/* { isHighRisk ? "高" : "低" }風險 */}
                            </div>
                            <div className="subtitle">
                                若您於上述任何一條問題回答「有」，就代表感染幽門螺旋桿菌風險較高，需要多加注意！
                            </div>
                            <div className="description">
                                其實香港約一半人都曾感染幽門螺旋桿菌<sup>2</sup>，大部份患者都沒有症狀。如不慎處理，幽門螺旋桿菌會導致嚴重的併發症，如胃黏膜發炎、十二指腸潰瘍，甚至胃癌<sup>14</sup>。幽門螺旋桿菌亦容易傳染給身邊的人，為確保健康，您可考慮網上預約專科醫生，作進一步檢查。
                                <br></br>
                                <br></br>
                            </div>
                            <div className="info">
                                FindDoc 快德香港現時聯乘阿斯利康（香港）藥廠，贊助香港市民進行免費幽門螺旋桿菌吹氣測試，立即按以下按鈕進行簡單報名，名額有限，先到先得！
                            </div>
                            <div className="self-test__test-result-content-container-buttons">
                                <a className="self-test__button primary" href={UrlService.preserveQuery("/patient-care/h-pylori/registration")} rel="noreferrer" target="_blank" onClick={track}>
                                    <SVGBooking /> &nbsp; 報名免費檢查
                                </a>
                                <button className="self-test__button secondary" onClick={handleResetClick}>
                                    <SVGRestart /> &nbsp; 重新評估
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HPyloriSelfTestResult;
